(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('bulkMailMenu', {
        templateUrl: 'views/components/views/bulkMailMenu/bulkMailMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'base64', 'stateService', 'bulkMailService', 'modalService', 'emailCreateService', 'ttGridFactory', 'graphAuthService', 'graphMailService', function ($stateParams, base64, stateService, bulkMailService, modalService, emailCreateService, ttGridFactory, graphAuthService, graphMailService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let bulkMailKeyno = $stateParams.bulkmail_keyno;

            vm.model = {
                emailTemplateNameButtons: [
                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('emailtemplate', { emailtemplate_keyno: vm.model.menu.emailtemplate_keyno }) }
                ],
                menu: {},
                gridReady: false
            };

            vm.grid = new ttGridFactory({
                rememberId: 'bulkmailmenu_bulkmaildata_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'bulkmailmenu_send_to_selected',
                text: 'bulkmailmenu_send_to_selected',
                func: sendToSelectedRows,
                icon: 'fa-reply-all',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true,
                disabled: () => {
                	if (getSelectedRows()?.length > 0) {
                		return false;
                	} else {
                		return 'hidden';
                	}
                }
            }]);
            
            // #endregion VARIABLES & DEFINITIONS

            // #region GRID FUNCTIONS

            function checkToolbarButtonsVisibility() {
                vm.grid?.gridfunc?.refreshToolbarBtnDisability();
            }

            function getSelectedRows() {
                return vm.grid?.gridfunc?.getAllRows().filter((row) => row.is_selected === true) ?? [];
            }

            function sendToSelectedRows() {
                let progress = {
                    runProgress: 'START',
                    label: 'progressbar',
                    field: '',
                    max: getSelectedRows()?.length ?? 0,
                    min: 0,
                    step: 0,
                    finishclose: '1',
                    abortclose: false,
                }

                modalService.progressInfo.max = getSelectedRows()?.length;

                modalService.showProgress(progress).then(function (value) {
                    progress.runProgress = value;

                    if (progress.runProgress === 'ABORT') {
                        console.log('ABORT');
                    } else if (progress.runProgress === 'FINISH') {
                        loadGrid();
                    }
                });

                // BJS 20250210 - Modified to run in an async context to enabled checking if user is logged in with graph and
                //                to use default email system if not logged in.
                (async () => {
                    let useGraphEmail = await graphAuthService.isAuthenticated();

                    let graphUserName = useGraphEmail ? (await graphAuthService.getAccount()).username : '';

                    getSelectedRows()?.forEach(async (row) => {
                        let email = await getEmailContent(row.bulkmaildata_keyno);

                        if (useGraphEmail) {
                            email.from_email = graphUserName;
                        }

                        await sendEmail(email, useGraphEmail);

                        modalService.progressInfo.step++;
                        progress.step++;
                    })
                })();
            }

            // #endregion GRID FUNCTIONS

            // #region LOAD EMAIL PROCEDURE FUNCTION CALLS

            async function getEmailContent(bulkmaildataKeyno) {
                return (await emailCreateService.getEmailCreate({ webpage: 'bulkmail', argtype: 'bulkmaildata_keyno', argvalue: bulkmaildataKeyno }))[0];
            }

            // BJS 20250210 - Added useGraphEmail parameter. Previously this was hardcoded to use graph.
            async function sendEmail(ttEmail, useGraphEmail) {
                try {
                    ttEmail.send_by_client = useGraphEmail;
                    ttEmail.email_heading = base64.urlencode(ttEmail.email_heading);
                    ttEmail.email_signature = base64.urlencode(ttEmail.email_signature);

                    const data = await emailCreateService.sendEmail(ttEmail);

                    if (data?.mailinfo && data.mailinfo.length > 0) {
                        data.mailinfo.forEach((mailinfo) => {
                            graphMailService.sendMessage({
                                subject: base64.urldecode(mailinfo.subject),
                                content: base64.urldecode(mailinfo.bodyHtml),
                                recipients: mailinfo.to,
                                ccRecipients: mailinfo.cc,
                                bccRecipients: mailinfo.bcc,
                                attachments: mailinfo.attachments,
                                userId: mailinfo.from
                            });
                        })
                    }
                } catch (error) {

                }
            }

            // #endregion LOAD EMAIL PROCEDURE FUNCTION CALLS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadMenu() {
                vm.model.menu = (await bulkMailService.getEdit({ bulkmail_keyno: bulkMailKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 3105,
                    parameters: { bulkmail_keyno: vm.model.menu.bulkmail_keyno }
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                await loadMenu();
                loadGrid();

                document.querySelector('mgt-login').addEventListener('loginCompleted', checkToolbarButtonsVisibility);
            }

            vm.$onDestroy = function () {
                document.querySelector('mgt-login').removeEventListener('loginCompleted', checkToolbarButtonsVisibility);
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
